const dialog = document.getElementById('kezvion-promo-popup');
const configEl = document.getElementById('kz-promo-config');
if (!dialog || !configEl || dialog.dataset.kzPromoInit) {
  /* already init or missing */
} else {
  dialog.dataset.kzPromoInit = '1';
  const config = JSON.parse(configEl.textContent);
  const form = document.getElementById('kz-promo-form');
  const errEl = dialog.querySelector('[data-kz-promo-error]');
  const stepForm = dialog.querySelector('[data-kz-promo-step="form"]');
  const stepSuccess = dialog.querySelector('[data-kz-promo-step="success"]');
  const copyBtn = dialog.querySelector('[data-kz-promo-copy]');
  const codeEl = dialog.querySelector('[data-kz-promo-code]');

  const show = () => {
    if (!dialog.open) dialog.showModal();
  };

  const hide = (dismissed = false) => {
    if (dialog.open) dialog.close();
    if (dismissed) {
      localStorage.setItem(config.storageKey, 'dismissed');
    }
  };

  const revealSuccess = () => {
    stepForm.hidden = true;
    stepSuccess.hidden = false;
    localStorage.setItem(config.storageKey, 'subscribed');
  };

  dialog.querySelectorAll('[data-kz-promo-close]').forEach((btn) => {
    btn.addEventListener('click', () => hide(true));
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) hide(true);
  });

  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    hide(true);
  });

  if (localStorage.getItem(config.storageKey) === 'subscribed') {
    /* already got code — stay quiet */
  } else if (localStorage.getItem(config.storageKey) !== 'dismissed') {
    window.setTimeout(show, config.delayMs);
  }

  form?.addEventListener('submit', () => {
    errEl.hidden = true;
  });

  form?.addEventListener('kezvion:form-posted', () => {
    revealSuccess();
  });

  form?.addEventListener('kezvion:form-error', () => {
    errEl.textContent = 'Something went wrong. Try again or email support@kezvion.com.';
    errEl.hidden = false;
  });

  copyBtn?.addEventListener('click', async () => {
    const code = codeEl?.textContent?.trim() || config.code;
    try {
      await navigator.clipboard.writeText(code);
      copyBtn.textContent = 'Copied';
      copyBtn.classList.add('is-copied');
      window.setTimeout(() => {
        copyBtn.textContent = 'Copy';
        copyBtn.classList.remove('is-copied');
      }, 2000);
    } catch {
      window.prompt('Copy your code:', code);
    }
  });
}
